<template>
  <NavPanel :panelNavLinks="panelNavLinks">
    <template
      v-for="(_, slot) in $slots"
      #[slot]="scope"
    >
      <slot
        :name="slot"
        v-bind="{...scope}"
      />
    </template>
  </NavPanel>
</template>

<script setup>
import { computed } from 'vue';

// Utils
import I18n from 'i18n-js';
import isKey from '@/functions/existing_key';
import isExistingIssue from '@/functions/existing_issue';
import { useRoute } from 'vue-router';
import { useShaftV2 } from '@/functions/use_remote_object';

// Components
import NavPanel from '@/components/issues/nav_panel.vue';

const route = useRoute();

const currentShaft = useShaftV2({ organisationId: route.params.organisationId, shaftId: route.params.shaftId });

const editLinks = [
    {
      id: 'Set',
      name: 'shaftV2IssueLocationSets',
      label: I18n.t('shafts.sets'),
    },
    {
      id: 'Station',
      name: 'shaftV2IssueLocationStations',
      label: I18n.t('shafts.stations'),
    },
    {
      id: 'Hme',
      name: 'shaftV2IssueLocationHmes',
      label: I18n.t('shafts.heavy_mobile_equipment'),
    }
  ];

const newLinks = [
    {
      id: 'Set',
      name: 'shaftV2NewIssueLocationSets',
      label: I18n.t('shafts.sets'),
    },
    {
      id: 'Station',
      name: 'shaftV2NewIssueLocationStations',
      label: I18n.t('shafts.stations'),
    },
    {
      id: 'Hme',
      name: 'shaftV2NewIssueLocationHmes',
      label: I18n.t('shafts.heavy_mobile_equipment'),
    }
  ];

const panelNavLinks = computed(() => {
  let links = [];

  const isHmePolicy = currentShaft.value?.policy?.heavy_mobile_equipment_enabled;

  if (isExistingIssue(route.params)) {
    // When editing the issue location it will only show the location type associated to the existing issue location
    switch (true) {
      case isKey(route.params, 'setId'):
        links = [ editLinks[0] ];
        break;
      case isKey(route.params, 'stationId'):
        links = [ editLinks[1] ];
        break;
      case isKey(route.params, 'heavyMobileEquipmentId'):
        links = [ editLinks[2] ];
        break;
    }
  } else {
    // When creating an issue location it will show all relevant location types to choose from
    links = [
      newLinks[0],
      newLinks[1],
    ];
    isHmePolicy && links.push(newLinks[2]);
  }

  return links;
});
</script>
